import i18n from '@/plugins/i18n';

export const consts = {
  userRoles: [
    {
      key: 'activityPerAffiliate',
      name: i18n.t('Activity per Affiliate')
    },
    {
      key: 'entryByAffiliate',
      name: i18n.t('Entry by Affiliate')
    },
    {
      key: 'paymentByAffiliate',
      name: i18n.t('Payment by Affiliate')
    },
    {
      key: 'user',
      name: i18n.t('Users')
    },
    {
      key: 'affiliate',
      name: i18n.t('Affiliates')
    },
    {
      key: 'action',
      name: i18n.t('Actions')
    },
    {
      key: 'campaign',
      name: i18n.t('Campaigns')
    },
    {
      key: 'reward',
      name: i18n.t('Rewards')
    },
    {
      key: 'rewardProfile',
      name: i18n.t('Reward Profile')
    },
    {
      key: 'brand',
      name: i18n.t('Brand')
    },
    {
      key: 'financial',
      name: i18n.t('Financial')
    },
    {
      key: 'partner',
      name: i18n.t('Partner')
    },
    {
      key: 'partnerLevel',
      name: i18n.t('Partner Level')
    },
    {
      key: 'subBrand',
      name: i18n.t('Sub Brand')
    },
    {
      key: 'company',
      name: i18n.t('Company')
    },
    {
      key: 'manager',
      name: i18n.t('Manager')
    }
  ]
};

export default consts;
